import {_getInsertReference, _setSelection} from './utils'
import {idGenerator} from '../../lib/utils/IdGenerator'

/**
 * Insert a node in the specified position and update selection.
 *
 * @param {Transaction} tx - Supplied Substance transaction
 * @param {Object} data - Type of text node to create
 * @param {String} mode - Mode, 'first', 'last', 'after'
 * @param {Object} inRefNode - Reference node from where to insert new node
 */
function insertBlockNode(tx, data, mode, inRefNode) {
    const strategy = _getInsertReference(tx, mode, inRefNode)
    const node = tx.create(data)

    if (!node.id) {
        node.id = idGenerator()
    }

    _setSelection(tx, strategy.mode, strategy.refNode)
    tx.insertBlockNode(node)

    if (node.ignorePosition !== true) {
        tx.setSelection({
            type: 'node',
            containerId: 'body',
            nodeId: node.id
        })
    }
    else {
        // As this is a special (temporary) node we need to set selection
        // to the reference node instead of the newly inserted node
        tx.setSelection({
            type: 'node',
            containerId: 'body',
            nodeId: strategy.refNode.id,
            mode: strategy.mode
        })
    }

    return node
}

export {insertBlockNode}
